import Controller from "../Engine/Controller";
//import Engine from "../Engine/Engine";
import cfJS from "../Engine/cfJS";
import TooltipManager from "./TooltipManager";

class Tooltip extends Controller {
    constructor(dom) {
        super(dom, "Tooltip");

        this.tooltip = null;
        this. tooltipButton = null;
        this._tooltipButtonListenHandler = null;

        //Protected params
        let that = this,
            domNode = this.domNode;

        try{
            function _init() {
                that.tooltipButton = cfJS.querySelector(domNode, ">.itsTooltipButton");
                that.tooltip = cfJS.querySelector(domNode, ">.Tooltip");

                _connectHandlers();
            }

            function _connectHandlers() {
                if (that.tooltipButton)
                    that._tooltipButtonListenHandler = cfJS.addListener(that.tooltipButton, "click", function (e) {
                        that.showTooltip();
                    });
            }

            _init();
        } catch (e) {
            console.log ("Tooltip.constructor error: "+e);
        }
    }
    /*public*/
    options (param) {
        this.param = param;

        if (param.style)
            cfJS.style(this.tooltip, param.style);
    }

    setCoordinates() {
        let coordinates = this.tooltip.getBoundingClientRect(),
            windows_coordinates = document.body.getBoundingClientRect(),
            buttonCoordinates = this.tooltipButton.getBoundingClientRect(),
            that = this;

        function _dropPosition() {
            cfJS.style(that.tooltip, "right", "0px");
            coordinates = that.tooltip.getBoundingClientRect();
        }

        //right
        if (coordinates.x+coordinates.width>windows_coordinates.width)
            _dropPosition();

        if (this.param.align) {
            for (let i =0; i<this.param.align.length; i++) {
                _dropPosition();

                cfJS.style(this.tooltip, "right", ((buttonCoordinates.x+buttonCoordinates.width) - (coordinates.x+coordinates.width))*-1+"px");

                //TODO - in future remove
                break;
            }
        }
    }

    hideTooltip() {
        this.domNode.classList.remove("show");
    }

    showTooltip () {
        //hide prev tooltip
        let lastOpenTooltip = TooltipManager.getLastOpenTooltip();

        if (lastOpenTooltip) {
            if (lastOpenTooltip!==this)
                lastOpenTooltip.hideTooltip();
        }

        this.domNode.classList.toggle("show");

        this.setCoordinates();

        //set last open tooltip
        TooltipManager.setLastOpenTooltip(this);
    }
}

window.Tooltip = Tooltip;